// extracted by mini-css-extract-plugin
export default {"base-text":"BaseText_base-text__fzFrs","checkbox-wrapper":"BaseText_checkbox-wrapper__gvbIm","checkbox":"BaseText_checkbox__IUch6","base-text-body":"BaseText_base-text-body__Hg2gr"};